import {
  Grid,
  CardHeader,
  CardContent,
  Box,
  TextField,
  Select,
  MenuItem,
  FormHelperText,
  FormControl,
  InputLabel,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiCategory } from "../../services/productService";
import { Form, FormikProvider, useFormik } from "formik";
import { SubcategorySchema } from "../../utils/Schema";
import errorHandler from "../../utils/errorHandler";
import { toast } from "react-toastify";
import LoadingButton from "@mui/lab/LoadingButton";
import CardLayout from "../../layouts/CardLayout";
import { trimFormValues } from "../../utils/helpers";

function AddEditSubCategory() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id, categoryid } = useParams();
  const [data, setData] = useState();

  // Fetch data for the edit mode
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiCategory.getByIdSubCategory({
          subCategoryId: id,
        });
        setData(response?.data?.data);
      } catch (error) {
        errorHandler(error);
      }
    };
    if (id) {
      fetchData();
    }
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: SubcategorySchema,
    initialValues: {
      id: data?._id || "",
      name: data?.name || "",
      status: data?.status || 1,
    },
    onSubmit: async (values) => {
      setLoading(true);
      try {
        // Trim all string values in the form values
        const trimmedValues = trimFormValues(values);

        if (id) {
          // Update subcategory
          const payload = {
            subCategoryId: id,
            categoryId:
              data?.parentCategory?._id || data?.parentCategory || categoryid,
            name: trimmedValues.name,
          };
          const response = await apiCategory.editSubCategory(payload);
          toast.success(response?.data?.message, { toastId: "success" });
        } else {
          // Create subcategory
          const payload = {
            categoryId: categoryid,
            name: trimmedValues.name,
          };
          const response = await apiCategory.addSubCategory(payload);
          toast.success(response?.data?.message, { toastId: "success" });
        }
        navigate(-1);
      } catch (error) {
        console.error(error);
        errorHandler(error);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Box>
      <title>{id ? "Edit" : "Add"} Sub Category</title>
      <CardLayout>
        <CardHeader title={`${id ? "Edit" : "Add"} Subcategory`} />
        <CardContent>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
              <Grid size={{ xs: 12, md: 12 }} sx={{ mt: 2 }}>
                <TextField
                  fullWidth
                  label="Subcategory Name"
                  value={formik.values.name}
                  onChange={(e) => formik.setFieldValue("name", e.target.value)}
                  onBlur={(e) =>
                    formik.setFieldValue("name", e.target.value.trim())
                  }
                  name="name"
                  error={Boolean(formik.touched.name && formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                  inputProps={{ maxLength: 50 }}
                  placeholder="e.g., Electric, Gas, Diesel, Hybrid"
                />
              </Grid>

              <Grid size={{ xs: 12 }} md={12}>
                <Box mt={3}>
                  <LoadingButton
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                    loading={loading}
                  >
                    {id ? "Update" : "Add"} Subcategory
                  </LoadingButton>
                </Box>
              </Grid>
            </Form>
          </FormikProvider>
        </CardContent>
      </CardLayout>
    </Box>
  );
}

export default AddEditSubCategory;
